// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export default from './Setup';



// WEBPACK FOOTER //
// ./views/smb/web/setup/index.js